<template>
  <div id='path-bar'>
    <slot></slot>
    <Breadcrumb :separator="separator">
      <BreadcrumbItem v-for="(item, index) in breadcrumb" :key="index" :to="item.to">
        {{ item.title }}
      </BreadcrumbItem>
    </Breadcrumb>
  </div>
</template>
<script>
import { Breadcrumb, BreadcrumbItem } from 'iview'

export default {
  name: 'PathBar',
  components: {
    Breadcrumb,
    BreadcrumbItem
  },
  props: {
    separator: {
      type: String
    },
    breadcrumb: {
      default: []
    }
  }
}

</script>
<style lang="less">
#path-bar {
  font-size: 14px;
  padding-top: 20px;
  padding-bottom: 20px;

  .ivu-breadcrumb a {
    color: #141414;

    &:hover {
      color: #e7970b;
    }
  }

  .ivu-breadcrumb>span:last-child {
    font-weight: normal;
    color: #333;
  }

  .ivu-breadcrumb-item-separator {
    color: #141414;
  }
}

</style>



// WEBPACK FOOTER //
// src/commons/components/PathBar.vue